import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useClock } from '../hooks/useClock';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getShiftDetails } from '../../../store/clock/selectors';

const Timer = () => {
  const { t } = useTranslation('clock');
  const shiftDetails = useAppSelector(getShiftDetails);
  const {
    time,
    clearTimer,
    startCounter,
    timeBegan,
  } = useClock();

  useEffect(() => {
    if (shiftDetails.started) {
      timeBegan.current = new Date(shiftDetails.startedAt);
      startCounter();
    }
    return () => {
      clearTimer();
    };
  }, [shiftDetails.started]);

  return (
    <>
      <Typography
        sx={{
          color: 'text.secondary',
        }}
        variant="body2"
      >
        {t('currentShift')}
      </Typography>
      <Typography paddingTop={1} variant="caption">
        {time}
      </Typography>
    </>
  );
};

export {
  Timer,
};
